import { KalturaMediaAsset } from '../../phoenix/objects';
import { processPhoenixImages } from '../../phoenix/processing';
import { fetchAsset } from '../../phoenix/services';

type FetchSunsetAsset = {
  id: string;
};

export async function fetchSunsetAsset({ id }: FetchSunsetAsset) {
  const asset = await fetchAsset<KalturaMediaAsset>({ id, assetReferenceType: 'media' });

  return {
    images: processPhoenixImages(asset.images),
  };
}
